import { render, staticRenderFns } from "./prodcuto-escaneado.vue?vue&type=template&id=542654ee&scoped=true&"
import script from "./prodcuto-escaneado.vue?vue&type=script&lang=ts&"
export * from "./prodcuto-escaneado.vue?vue&type=script&lang=ts&"
import style0 from "./prodcuto-escaneado.vue?vue&type=style&index=0&id=542654ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542654ee",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VIcon,VRow})
